import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { Dropdown } from "component/menu";
import { TableList } from "component/list";
import { FilterList } from "component/list";

import { currencyFormatter } from "utils/currencyHelper";

import "containers/WalletTransactions/styles.scss";

import { ReactComponent as SortArrowDown } from "assets/icons/sort-arrow-down.svg";
import { ReactComponent as SortArrowUp } from "assets/icons/sort-arrow-up.svg";
import { withNamespaces } from "react-i18next";

class WalletTransactions extends Component {
  constructor(props) {
    super(props);
    this.fetchList = this._fetchList.bind(this);
    this.fetchAvailableMonths = this._fetchAvailableMonths.bind(this);
    this.fetchAvailableReferenceTypes = this._fetchAvailableReferenceTypes.bind(
      this
    );
    this.onSort = this._onSort.bind(this);
    this.state = {
      availableMonths: null,
      selectedMonthIndex: null,
      availableReferenceTypes: null,
      selectedReferenceTypeIndex: null,
      isLoading: false,
      isLoadingNext: false,
      walletTransactions: null,
      listComplete: null,
      sort: {
        orderBy: "DESC",
        sortBy: "createdDate",
      },
    };
  }

  _fetchAvailableReferenceTypes() {
    this.setState({
      availableReferenceTypes: null,
      selectedReferenceTypeIndex: null,
    });

    let selectedMonth = this.state.availableMonths.get(
      this.state.selectedMonthIndex
    );

    let params = {
      month: selectedMonth ? selectedMonth.get("id") : null,
    };

    this.props
      .fetchWalletTransactionsAvailableReferenceTypes(
        this.props.walletTransactionsAvailableReferenceTypesLink,
        params
      )
      .then((response) => {
        this.props.setWalletTransactionsAvailableReferenceTypes(response);
        this.setState({
          availableReferenceTypes: response,
        });
      });
  }

  _fetchAvailableMonths() {
    this.props
      .fetchWalletTransactionsAvailableMonths(
        this.props.walletTransactionsAvailableMonthsLink
      )
      .then((response) => {
        let initialMonthIndex = 0;
        if (this.props.historyMonthId && response) {
          const historyMonthIndex = response.findIndex(
            (month) => month.get("id") === this.props.historyMonthId
          );
          if (historyMonthIndex !== -1) {
            initialMonthIndex = historyMonthIndex;
          }
        }

        this.props.setWalletTransactionsAvailableMonths(response);
        this.setState({
          availableMonths: response,
          selectedMonthIndex: response.size === 0 ? null : initialMonthIndex,
          availableReferenceTypes: response.size === 0 ? [] : null,
        });
      });
  }

  _fetchList(page) {
    if (!page) {
      this.setState({
        walletTransactions: null,
      });
    }

    if (
      (this.state.availableMonths && this.state.availableMonths.size === 0) ||
      (this.state.walletTransactions &&
        page > this.state.walletTransactions.get("totalPages"))
    ) {
      this.setState({
        listComplete: true,
      });
      return;
    }

    this.setState({
      isLoading: true,
      listComplete: false,
    });

    let selectedMonth = this.state.availableMonths.get(
      this.state.selectedMonthIndex
    );

    let params = {
      month: selectedMonth ? selectedMonth.get("id") : null,
      page: page,
      orderBy: this.state.sort.orderBy,
      sortBy: this.state.sort.sortBy,
    };

    if (this.state.selectedReferenceTypeIndex !== null) {
      let selectedReferenceType = this.state.availableReferenceTypes.get(
        this.state.selectedReferenceTypeIndex
      );
      params.referenceType = selectedReferenceType.get("id");
    }

    this.props
      .fetchWalletTransaction(this.props.walletTransactionsLink, params)
      .then((response) => {
        let newWalletTransactions = response;

        if (this.state.walletTransactions && page) {
          newWalletTransactions = newWalletTransactions.setIn(
            ["items"],
            this.state.walletTransactions
              .get("items")
              .concat(response.getIn(["items"]))
          );
        }

        this.props.setWalletTransactions(newWalletTransactions);
        this.setState({
          walletTransactions: newWalletTransactions,
          isLoading: false,
        });
      });
  }

  _onSort(value) {
    let orderBy;

    if (value !== this.state.sort.sortBy) orderBy = "DESC";
    else if (this.state.sort.orderBy === "DESC") orderBy = "ASC";
    else if (this.state.sort.orderBy === "ASC") orderBy = "DESC";

    let newSort = {
      sortBy: value,
      orderBy,
    };

    this.setState({
      sort: newSort,
    });
  }

  componentDidMount() {
    if (this.props.walletTransactionsAvailableMonthsLink) {
      this.fetchAvailableMonths();
    }
  }

  componentDidUpdate(prevProps, prevState, snapShot) {
    if (
      prevProps.walletTransactionsAvailableMonthsLink !==
        this.props.walletTransactionsAvailableMonthsLink &&
      this.props.walletTransactionsAvailableMonthsLink
    ) {
      this.fetchAvailableMonths();
    }

    if (
      prevState.selectedMonthIndex !== this.state.selectedMonthIndex &&
      this.state.selectedMonthIndex !== null
    ) {
      this.fetchAvailableReferenceTypes();
      this.fetchList();
    }

    if (prevState.sort !== this.state.sort) {
      this.fetchList();
    }

    if (
      prevState.selectedReferenceTypeIndex !==
      this.state.selectedReferenceTypeIndex
    ) {
      this.fetchList();
    }
  }

  setLabel(id) {
    let { t } = this.props;
    try {
      switch (id) {
        case "createdDate":
          let CArrow =
            this.state.sort.orderBy === "DESC" ? SortArrowDown : SortArrowUp;
          return (
            <span
              className={`label-with-sort ${
                this.state.sort.sortBy === "createdDate" ? "selected" : ""
              }`}
            >
              {t(id)}
              {this.state.sort.sortBy === "createdDate" && (
                <div className="arrow nopadding d-none align-items-center">
                  <CArrow />
                </div>
              )}
            </span>
          );
        case "balance":
          return <div className="text-right">{t(id)}</div>;
        case "amount":
          let AArrow =
            this.state.sort.orderBy === "DESC" ? SortArrowDown : SortArrowUp;
          return (
            <div className="text-right">
              <span
                className={`label-with-sort right ${
                  this.state.sort.sortBy === "amount" ? "selected" : ""
                }`}
              >
                {t(id)}
                {this.state.sort.sortBy === "amount" && (
                  <div className="arrow nopadding d-none align-items-center">
                    <AArrow />
                  </div>
                )}
              </span>
            </div>
          );
        default:
          return <div>{t(id)}</div>;
      }
    } catch {
      return id;
    }
  }

  setValue(item) {
    switch (item.id) {
      case "balance":
      case "amount":
        return this.renderAmount(item);
      case "createdDate":
        return this.renderDate(item);
      default:
        return item.value;
    }
  }

  renderAmount(item) {
    let value = currencyFormatter(item.value, {
      symbol: this.props.symbol,
      decimalPlaces: this.props.decimalPlaces,
    });

    return <div className="text-right">{value}</div>;
  }

  renderDate(item) {
    if (item.value === "" || !item.value) return null;

    const date = item.value.split(" ");
    return (
      <Fragment>
        <span className="d-flex">{`${date[0]} ${date[1]} `}</span>
        <span className="d-flex">{`${date[2]}`}</span>
      </Fragment>
    );
  }

  renderHeaderSkeleton(key) {
    switch (key) {
      case 3:
      case 4:
        return (
          <th key={key} className="text-right">
            <span className="dummy">loading</span>
          </th>
        );
      default:
        return (
          <th key={key}>
            <span className="dummy">loading</span>
          </th>
        );
    }
  }

  renderSkeleton(key) {
    switch (key) {
      case 0:
        return (
          <td key={key}>
            <span className="dummy">loading</span>
            <br />
            <span className="dummy">loading</span>
          </td>
        );
      case 1:
        return (
          <td key={key}>
            <span className="dummy">XXXXXXXXXXXXXXXXXXXXX</span>
          </td>
        );
      case 3:
      case 4:
        return (
          <td key={key} className="text-right">
            <span className="dummy">loading</span>
          </td>
        );
      default:
        return (
          <td key={key}>
            <span className="dummy">loading</span>
          </td>
        );
    }
  }

  render() {
    let { t } = this.props;
    return (
      <div className="wallet-transactions">
        <FilterList
          list={this.state.availableReferenceTypes}
          selectedIndex={this.state.selectedReferenceTypeIndex}
          skeletonCount={3}
          handleChange={(index) => {
            this.setState({
              selectedReferenceTypeIndex:
                index === this.state.selectedReferenceTypeIndex ? null : index,
            });
          }}
        />
        <div className="header-sub-title">
          {this.state.availableMonths && this.state.availableMonths.size > 0 && (
            <Fragment>
              <span>
                {this.state.walletTransactions &&
                  `${this.state.walletTransactions.get("totalCount")} ${t(
                    "transactionsIn"
                  )}`}
                {!this.state.walletTransactions && (
                  <span className="dummy">loading loading</span>
                )}
              </span>
              <span className="dropdown-container">
                <Dropdown
                  availableMonths={this.state.availableMonths}
                  selectedMonth={this.state.availableMonths.getIn([
                    this.state.selectedMonthIndex,
                    "name",
                  ])}
                  handleChange={(id, name, index) => {
                    this.setState({
                      selectedMonthIndex: index,
                    });
                  }}
                />
              </span>
            </Fragment>
          )}
          {!this.state.availableMonths && (
            <span className="dummy">loading loading</span>
          )}
        </div>
        <TableList
          list={this.state.walletTransactions}
          initiated={
            this.state.availableMonths && this.props.walletTransactionsLink
              ? true
              : false
          }
          isLoading={this.state.isLoading}
          listComplete={this.state.listComplete}
          onSort={this.onSort}
          onReachEnd={() => {
            let page = this.state.walletTransactions
              ? this.state.walletTransactions.get("page") + 1
              : null;
            this.fetchList(page);
          }}
          setLabel={(id) => {
            return this.setLabel(id);
          }}
          setValue={(item) => {
            return this.setValue(item);
          }}
          setSkeleton={(key) => {
            return this.renderSkeleton(key);
          }}
          setHeaderSkeleton={(key) => {
            return this.renderHeaderSkeleton(key);
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let walletTransactionsLink;
  let walletTransactionsAvailableMonthsLink;
  let walletTransactionsAvailableReferenceTypesLink;
  let historyMonthId = ownProps.historyMonthId;

  try {
    walletTransactionsLink = state.historyLinks.find((link) => {
      return link.get("rel") === "wallet-transactions";
    });
  } catch (err) {}
  try {
    walletTransactionsAvailableMonthsLink = walletTransactionsLink
      .get("links")
      .find((link) => {
        return link.get("rel") === "wallet-transactions.available-months";
      });
  } catch (err) {}
  try {
    walletTransactionsAvailableReferenceTypesLink = walletTransactionsLink
      .get("links")
      .find((link) => {
        return (
          link.get("rel") === "wallet-transactions.available-reference-types"
        );
      });
  } catch (err) {}

  return {
    walletTransactionsLink,
    walletTransactionsAvailableMonthsLink,
    walletTransactionsAvailableReferenceTypesLink,
    decimalPlaces: state.links.get("decimalPlaces"),
    historyMonthId,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    logout: () => dispatchProps.logout(),
    fetchWalletTransactionsAvailableMonths: (route, params) =>
      dispatchProps.fetchWalletTransactionsAvailableMonths(route, params),
    setWalletTransactionsAvailableMonths: (payload) =>
      dispatchProps.setWalletTransactionsAvailableMonths(payload),
    fetchWalletTransaction: (route, params) =>
      dispatchProps.fetchWalletTransaction(route, params),
    setWalletTransactions: (payload) =>
      dispatchProps.setWalletTransactions(payload),
    fetchWalletTransactionsAvailableReferenceTypes: (route, params) =>
      dispatchProps.fetchWalletTransactionsAvailableReferenceTypes(
        route,
        params
      ),
    setWalletTransactionsAvailableReferenceTypes: (payload) =>
      dispatchProps.setWalletTransactionsAvailableReferenceTypes(payload),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withNamespaces("translation")(WalletTransactions));
